import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/public.css'
import axios from 'axios'
// 配置请求根路径
// axios.defaults.baseURL = 'http://120.24.239.84:8701' 
axios.defaults.baseURL = 'https://ht.jiuhangjituan.com/api/' 

axios.interceptors.request.use(config => {
  /* NProgress.start() */
  // console.log(config)
  // 为请求头对象，添加token验证的Authorization字段
  config.headers.Authorization = window.sessionStorage.getItem('jiuhangtoken')
  // 在最后必须 return config
  return config
})
// 挂在到Vue实例，后面可通过this调用
Vue.prototype.$http = axios

Vue.prototype.$imgTitle = 'http://group.jiuhangjituan.cn/'
Vue.prototype.$httpTitle = 'http://120.24.239.84:8701'//http://xhm.jiuhuakang.com' http://120.24.239.84:8701
// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// 导入富文本编辑器样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false
// 全局注册富文本编辑器
Vue.use(VueQuillEditor)

Vue.filter('dataFormat', function (timeStamp) {
 var date = new Date();
 date.setTime(timeStamp);
 var y = date.getFullYear();
 var m = date.getMonth() + 1;
 m = m < 10 ? ('0' + m) : m;
 var d = date.getDate();
 d = d < 10 ? ('0' + d) : d;
 var h = date.getHours();
 h = h < 10 ? ('0' + h) : h;
 var minute = date.getMinutes();
 var second = date.getSeconds();
 minute = minute < 10 ? ('0' + minute) : minute;
 second = second < 10 ? ('0' + second) : second;
 return y + '年' + m + '月' + d +'日'; //+ ' ' + h + ':' + minute + ':' + second;

})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
